/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MemberTierTranslationResponseDto } from './memberTierTranslationResponseDto';
import { SpecialPricePartialRateResponseDto } from './specialPricePartialRateResponseDto';

export interface MemberTierResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  translations: Array<MemberTierTranslationResponseDto>;
  isActive: boolean;
  sequence: number;
  priceType: MemberTierResponseDto.PriceTypeEnum;
  specialRate: number;
  relativePriceType: MemberTierResponseDto.RelativePriceTypeEnum;
  specialPricePartialRates: Array<SpecialPricePartialRateResponseDto>;
  noOfMember: number;
}
// tslint:disable-next-line:no-namespace
export namespace MemberTierResponseDto {
  export type PriceTypeEnum = 'normal_price' | 'special_price' | 'special_price_partial';
  export const PriceTypeEnum = {
      NormalPrice: 'normal_price' as PriceTypeEnum,
      SpecialPrice: 'special_price' as PriceTypeEnum,
      SpecialPricePartial: 'special_price_partial' as PriceTypeEnum,
  };
  export type RelativePriceTypeEnum = 'relative_amount' | 'relative_percentage';
  export const RelativePriceTypeEnum = {
      Amount: 'relative_amount' as RelativePriceTypeEnum,
      Percentage: 'relative_percentage' as RelativePriceTypeEnum,
  };
}
